import React from 'react';
import { Card, Badge, Button } from '@/components/ui';
import { formatCurrency, formatDate } from '@/utils/format';
import type { ConstructionVariation } from '../types/construction-boq.types';

interface BoqVariationPanelProps {
  variations: ConstructionVariation[];
  onManage: () => void;
}

export function BoqVariationPanel({ variations, onManage }: BoqVariationPanelProps) {
  const approvedTotal = variations
    .filter(v => v.status_code === 'approved')
    .reduce((sum, v) => sum + v.total_amount, 0);

  return (
    <Card className="overflow-hidden border-none shadow-sm">
      <div className="p-4 bg-slate-50 border-b border-slate-100 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <h3 className="text-sm font-bold text-slate-700  tracking-wider">Phát sinh (VO)</h3>
          <Badge variant="neutral" className="bg-os-primary/10 text-os-primary border-none">
            {variations.length} phiếu
          </Badge>
        </div>
        <Button variant="ghost" size="sm" icon="ri-external-link-line" onClick={onManage}>
          Chi tiết VO
        </Button>
      </div>

      <div className="p-4 space-y-4">
        {variations.length === 0 ? (
          <div className="text-center py-6 text-slate-400 text-sm italic">Chưa có phát sinh được ghi nhận.</div>
        ) : (
          <>
            <div className="grid grid-cols-2 gap-4 pb-4 border-b border-slate-50">
              <div>
                <p className="text-[10px] text-slate-400 font-bold  mb-1">Tổng cộng đã duyệt</p>
                <p className={`text-lg font-bold ${approvedTotal >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                  {approvedTotal >= 0 ? '+' : ''}{formatCurrency(approvedTotal)}
                </p>
              </div>
              <div>
                <p className="text-[10px] text-slate-400 font-bold  mb-1">Phiếu mới nhất</p>
                <p className="text-sm font-bold text-slate-900 line-clamp-1">{variations[0]?.vo_name}</p>
              </div>
            </div>
            <div className="space-y-2">
              {variations.slice(0, 3).map(v => (
                <div key={v.id} className="flex justify-between items-center text-xs">
                  <div className="flex items-center gap-2">
                    <span className="font-mono text-[10px] text-slate-400">#{v.vo_code}</span>
                    <span className="font-medium text-slate-700">{v.vo_name}</span>
                  </div>
                  <span className={`font-bold ${v.total_amount >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                    {v.total_amount >= 0 ? '+' : ''}{formatCurrency(v.total_amount)}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </Card>
  );
}
